module.exports = __webpack_public_path__ + "img/img_certification_mark_01.87704bf.svg";